import Axios from "axios";
import { SETTINGS } from "../properties/Settings";

export const ExportExcelRepository = {
  exportToXlsx: (searchParams, orderBy, orderDirection) => {
    const params = {};
    if (searchParams) {
      params.filterParams = JSON.stringify(searchParams);
    }

    params.orderBy = orderBy;
    params.orderDirection = orderDirection;

    return Axios.get(`${SETTINGS.API_URL}exports/exportToXlsx`, {
      params,
      responseType: "blob",
    });
  },
};
